/**
 * Checks if the value is undefined || null || '' (EMPTY)
 * @param {unknown} value the value to check
 * @returns {boolean} true or false
 */

export function isUndefinedOrEmpty(value: unknown): boolean {
  return value === undefined || value === null || value === '';
}
